// extracted by mini-css-extract-plugin
export default {"mapWrap":"mapStyle_mapWrap__0j-1V","mapTitle":"mapStyle_mapTitle__7gWc1","map":"mapStyle_map__VWiOD"};